import React, { useEffect, useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { affiliateCommissionsService } from 'v2/services/reports/affiliateCommissions';

import { Details } from './Details';
import { DetailsModal } from './DetailsModal';
import { Filter } from './Filter';
import { Table } from './Table';
import Breadcrumbs from '../Breadcrumbs';

export const AffiliateCommissions = () => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [isLoadingAccount] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [requestAffiliateCommissionsDetails] = useCallbackObservable(
    affiliateId => affiliateCommissionsService.requestAffiliateCommissionsDetails(affiliateId),
    []
  );

  useEffect(() => {
    return () => affiliateCommissionsService.cleanFilter();
  }, []);

  if (isLoadingAccount || !user) return null;

  const handleSeeDetailsClick = (partnerId: number) => {
    requestAffiliateCommissionsDetails(partnerId);
    setIsDetailsModalOpen(true);
  };

  const closeDetailsModal = () => setIsDetailsModalOpen(false);

  const breadcrumbsLink = [
    {
      url: '/producer/reports/sales',
      name: 'Relatórios'
    }
  ];

  return (
    <>
      <Breadcrumbs navList={breadcrumbsLink} currentPage='Comissões Pagas a Afiliados' />
      <TopPage title='Comissões Pagas a Afiliados' disableAlerts />

      <Filter />
      <Details />
      <DetailsModal handleClose={closeDetailsModal} isOpen={isDetailsModalOpen} />
      <Table handleSeeDetailsClick={handleSeeDetailsClick} />
    </>
  );
};
